import { i18n } from 'i18n';

const translations = (): Record<string, string> => ({
  FRONT: i18n._('ViewCubeFront', {}, { message: 'FRONT' }),
  BACK: i18n._('ViewCubeBack', {}, { message: 'BACK' }),
  LEFT: i18n._('ViewCubeLeft', {}, { message: 'LEFT' }),
  RIGHT: i18n._('ViewCubeRight', {}, { message: 'RIGHT' }),
  TOP: i18n._('ViewCubeTop', {}, { message: 'TOP' }),
  BOTTOM: i18n._('ViewCubeBottom', {}, { message: 'BOTTOM' }),
  N: i18n._('ViewCubeNorth', {}, { message: 'N' }),
  E: i18n._('ViewCubeEast', {}, { message: 'E' }),
  S: i18n._('ViewCubeSouth', {}, { message: 'S' }),
  W: i18n._('ViewCubeWest', {}, { message: 'W' }),
});

// The geometry names faces and compass points by their English label; this is the text drawn on them.
const viewCubeLabel = (id: string): string => translations()[id] ?? id;

export default viewCubeLabel;
